export var transformToRequestObject = function (formData) {
    var encrypt = formData.encrypt, password = formData.password, userFiles = formData.userFiles;
    var userFilesArray = userFiles ? userFiles.split('\n').map(function (file) { return file.trim(); }) : [];
    var updatedFormData = encrypt ? { password: password, user_files: userFilesArray } : { user_files: userFilesArray };
    return updatedFormData;
};
